import type { AgentHistoryEntry } from "@/context/agent/types.ts";
import type { FC } from "react";
import cn from "classnames";
import styles from "@/layout/agentChat/agentChatDrawer.module.scss";
import IconButton from "@mui/material/IconButton";
import { SparkleIcon } from "@phosphor-icons/react/Sparkle";
import { useTranslation } from "react-i18next";

type ResponseViewProps = {
  entry: AgentHistoryEntry;
}

const ResponseView: FC<ResponseViewProps> = ({ entry }) => {
  const { t } = useTranslation("translation", { keyPrefix: "agentChat" });

  if (!entry.response) {
    return null;
  }

  return (
    <div className={cn(styles.messageRow, styles.responseRow)}>
      <div className={cn(styles.messageBubble, styles.responseBubble)}>
        <div className={styles.messageLabel} data-rowtype="response">
          <IconButton className={styles.messageLabelIcon}>
            <SparkleIcon size={14} />
          </IconButton>
          <span>{t("agentLabel")}</span>
        </div>
        <div className={styles.messageText} dangerouslySetInnerHTML={{ __html: entry.response }} />
      </div>
    </div>
  );
};

export default ResponseView;
